import React, { useState } from "react";
import { Button, MenuItem, Stack, TextField, Typography } from "@mui/material";

const INITIAL_SEED = {
  sport: "mlb",
  playerIds: "",
  season: "",
  url: "",
  topic: "",
};

const toPayload = (seed) => ({
  sport: seed.sport,
  playerIds: seed.playerIds
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean),
  ...(seed.season ? { season: Number(seed.season) } : {}),
  ...(seed.url.trim() ? { url: seed.url.trim() } : {}),
  ...(seed.topic.trim() ? { topic: seed.topic.trim() } : {}),
});

const ManualSeedForm = ({ disabled = false, onSubmit }) => {
  const [seed, setSeed] = useState(INITIAL_SEED);
  const updateField = (event) => {
    const { name, value } = event.target;
    setSeed((current) => ({ ...current, [name]: value }));
  };
  const submit = async (event) => {
    event.preventDefault();
    const result = await onSubmit(toPayload(seed));
    if (result?.success) setSeed(INITIAL_SEED);
  };

  return (
    <Stack component="form" onSubmit={submit} spacing={1.5}>
      <Typography variant="subtitle2">Add a manual opportunity</Typography>
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.5}>
        <TextField
          label="Sport"
          name="sport"
          onChange={updateField}
          select
          size="small"
          value={seed.sport}
        >
          {["mlb", "nba", "nfl"].map((sport) => (
            <MenuItem key={sport} value={sport}>
              {sport}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Player IDs"
          name="playerIds"
          onChange={updateField}
          placeholder="id-one, id-two"
          size="small"
          value={seed.playerIds}
        />
        <TextField
          inputProps={{ min: 1800 }}
          label="Season"
          name="season"
          onChange={updateField}
          size="small"
          type="number"
          value={seed.season}
        />
      </Stack>
      <TextField
        label="URL"
        name="url"
        onChange={updateField}
        size="small"
        value={seed.url}
      />
      <TextField
        label="Topic"
        name="topic"
        onChange={updateField}
        size="small"
        value={seed.topic}
      />
      <Button disabled={disabled} type="submit" variant="outlined">
        Add opportunity
      </Button>
    </Stack>
  );
};

export default ManualSeedForm;
